<template>
    <h2>Foo{{$route.params.id}}</h2>
</template>

<script>
    export default ({
        name: "foo",

    })
</script>

<style>

</style>